import React from 'react';
import {connect} from 'react-redux';
import {getProducts} from "../../store/actions/products";
import Price from '../../shared/price';
import {addToCart} from "../../store/actions/cart";
import './Product.css';
import {FaArrowLeft, FaCartPlus} from 'react-icons/fa';
import Modal from './Modal';
import {sendAnalytics} from "../../store/actions/analytics";


class Product extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            alreadyInCart: false,
            addToCart: false,
            orderedProducts: [],
            nextItem: 0
        }
    }

    componentDidMount() {
        window.addEventListener('beforeunload', this.listenToTabClose);
        if (this.props.products.length < 1) {
            this.props.getProducts();
        } else {
            let allProds = this.props.products.filter(prod => prod.visible)
            let orderedProducts = []
            allProds.forEach((indexedProduct) => {
                orderedProducts.push(indexedProduct.id)
            })
            this.setState({orderedProducts: orderedProducts});
        }



    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.indexedProducts === null && this.props.indexedProducts !== null) {
            let allProds = this.props.products.filter(prod => prod.visible)
            let orderedProducts = []
            allProds.forEach((indexedProduct) => {
                orderedProducts.push(indexedProduct.id)
            })
            this.setState({orderedProducts: orderedProducts});
        }

        if (prevState.orderedProducts.size < 0 && this.props.indexedProducts) {
        }
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.listenToTabClose);
    }

    listenToTabClose = () => {
        let product;
        if (this.props.indexedProducts) {
            product = this.props.indexedProducts[this.props.match.params.id];
        }
        if (product && product.descriptiveName){
            this.props.sendAnalytics(`User Ended Session - ${product.descriptiveName} Product Page`)
        }else {
            this.props.sendAnalytics(`User Ended Session - ProductID: ${this.props.match.params.id} Product Page`)
        }
    }

    addItemToCart(e, item) {
        e.preventDefault();

        const alreadyInCart = this.props.cartItems.find(cart => cart.id === item.id);
        if (alreadyInCart) {
            this.setState({alreadyInCart: true});
        } else {
            this.setState({addToCart: true});
            this.props.addToCart(item);

            this.props.sendAnalytics(`${item.descriptiveName} Added to Cart`)
        }
    }

    getNextItem() {
        if (!this.props.products) {
            this.props.getProducts();
            return
        }
        const orderedProducts = this.state.orderedProducts
        const isInArray = (element) => element.toFixed() === (this.props.match.params.id * 1).toFixed();
        let thisProductsIndex = orderedProducts.findIndex(isInArray)
        let nextItem;
        if (thisProductsIndex >= 0 && thisProductsIndex < orderedProducts.length - 1) {
            nextItem = orderedProducts[thisProductsIndex + 1]
        } else {
            nextItem = orderedProducts[0]
        }
        return nextItem
    }


    getPreviousItem() {
        const orderedProducts = this.state.orderedProducts
        const isInArray = (element) => element.toFixed() === (this.props.match.params.id * 1).toFixed();
        let thisProductsIndex = orderedProducts.findIndex(isInArray)
        let nextItem;
        if (thisProductsIndex >= 0 && thisProductsIndex < orderedProducts.length - 1) {
            nextItem = orderedProducts[thisProductsIndex - 1]
        } else {
            nextItem = orderedProducts[0]
        }
        return nextItem
    }

    render() {
        let product;
        if (this.props.indexedProducts) {
            product = this.props.indexedProducts[this.props.match.params.id];
            this.getNextItem()
            this.props.sendAnalytics(`${product.descriptiveName} Product Page Viewed`)
        }

        if (product) {
            let items = product.products
                .filter(product => product.visible)
                .map((item, index) =>
                    <div key={index} className="item">
                        <form className="productForm" onSubmit={e => this.addItemToCart(e, item)}>


                            <div className="priceRow">
                                <div className="priceDesktop">Now: <Price price={item.price}/></div>
                                <div className="normalPrice">
                                    Was: <span>${item.id === 67 ? '9,997' : (item.price + item.price * 2.3333).toFixed()}</span>
                                </div>
                            </div>


                            <div className="youSave">You save 70%
                                (${Math.floor((item.price + item.price * 2.3333).toFixed() - item.price)})
                            </div>

                            <button type="submit" className="add-to-cart-btn"><FaCartPlus/> Add to cart</button>
                        </form>
                    </div>
                );

            return (
                <div className="productInformationRows">


                    {
                        this.props.match.params.id * 1 === 24 ?
                            <div className="dealBannerDesktop">
                                <div className="dealBannerText">
                                    <span className="noticeText">****** </span>
                                    PURCHASE THIS COURSE AND PAY ONLY <u>$1</u> FOR ANY OTHER COURSE IN THIS STORE
                                    <span className="noticeText"> ******</span>
                                </div>
                            </div>
                            :
                            <div className="dealBannerDesktop">
                                <div className="dealBannerText">
                                    <span className="noticeText">****** </span>
                                    <span className="noticeText"> ******</span>
                                </div>
                                <div className="dealBannerText">
                                </div>
                            </div>
                    }

                    {
                        this.props.match.params.id * 1 === 24 ?
                            <div className="dealBannerMobile">
                                <div className="dealBannerText">
                                    PURCHASE THIS COURSE AND PAY ONLY <u>$1</u> FOR ANY OTHER COURSE IN THIS STORE
                                </div>
                            </div>
                            :
                            <div className="dealBannerMobile">
                                <div className="dealBannerText">
                                    THIS ITEM COULD BE YOURS FOR $1
                                </div>
                                <div className="dealBannerText">
                                    Purchase the <span className="slscLink">Straight Line Sales Certification</span> and
                                    pay only $1 for EVERY item in this store!
                                </div>
                            </div>
                    }


                    <div className="productNavButtons">
                        <div className="buttonsBox">
                            <div>
                                <button
                                    type="button"
                                    className="back-btn"
                                    onClick={() => this.props.history.push('/')}>
                                    <FaArrowLeft className="arrow-icon"/>
                                    <span className="button-text">Back to shop</span>
                                </button>
                            </div>
                        </div>
                        <div>
                            <div className="backNextButtonContainer">
                                <div className="buttonBrackets"> {"<"} </div>
                                <button
                                    type="button"
                                    className="navButton"
                                    onClick={() => this.props.history.push(`/products/${this.getPreviousItem()}`)}>
                                    <span className="navButtonText">PREVIOUS</span>
                                </button>
                                |
                                <button
                                    type="button"
                                    className="navButton"
                                    onClick={() => this.props.history.push(`/products/${this.getNextItem()}`)}>
                                    <span className="navButtonText">NEXT</span>
                                </button>
                                <div className="buttonBrackets"> {">"} </div>
                            </div>

                        </div>
                    </div>
                    <div className="product-container">
                        {this.props.loading ? 'PRODUCT LOADING..' : null}
                        {this.state.alreadyInCart ?
                            <Modal
                                exitModal={() => this.setState({alreadyInCart: false})}
                                redirect={() => this.props.history.push('/cart')}
                            >
                                Item is already in your cart!
                            </Modal> : null
                        }
                        {this.state.addToCart ?
                            <Modal
                                exitModal={() => this.setState({addToCart: false})}
                                redirect={() => this.props.history.push('/cart')}
                            >
                                Item has been added to your cart!
                            </Modal> : null
                        }
                        <div className="product-info">
                            {
                                product.links ?
                                    <img src={product.links.thumbnail} alt="Product Thumbnail"
                                         className="product-img"/> :
                                    null
                            }

                        </div>
                        <div className="name-and-items">
                            <div className="product-name">
                                <div className="discountTagProduct">
                                    <div className="discountTagMessageProduct">Sale</div>
                                </div>

                                <div className="productDescriptiveName">{product.descriptiveName}</div>
                                <div className="underlineProductName"/>

                            </div>
                            <div className="product-items">
                                {items}
                            </div>

                            <div className="scrollDescription">
                                {product.description.split('\n').map((item, index) => {
                                    return (<div className="product-text" key={index}>{item}<br/></div>)
                                })}


                            </div>


                        </div>
                    </div>

                </div>
            );
        } else {
            return null;
        }
    }
}

const mapStateToProps = state => ({
    products: state.productsReducer.products,
    loading: state.productsReducer.loading,
    indexedProducts: state.productsReducer.indexedProducts,
    cartItems: state.cartReducer.cart
});

const mapDispatchToProps = dispatch => ({
    getProducts: () => dispatch(getProducts()),
    addToCart: (item) => dispatch(addToCart(item)),
    sendAnalytics: (eventTag) => dispatch(sendAnalytics(eventTag))
});

export default connect(mapStateToProps, mapDispatchToProps)(Product);
